import React from "react";
import AsyncSelect from "react-select/async";
import { api } from "../../api/api";

export const searchMembers = async (inputValue) => {
  if (!inputValue || inputValue.trim().length < 2) return [];
  try {
    const login = JSON.parse(
      localStorage.getItem("connectToFitGymPanelUser") || "{}"
    );
    const res = await api(
      `memberAll?gym=${login.gym}&search=${encodeURIComponent(
        inputValue.trim()
      )}`,
      {},
      "get"
    );
    if (!res || res.status !== 200 || !res.data || !res.data.data) return [];
    return res.data.data.map((item) => ({
      label: `${item.name}-${item.phone ? item.phone : "No Phone"}`,
      value: item,
    }));
  } catch (error) {
    return [];
  }
};

export const MemberSearch = ({ onSelect, onCancel }) => (
  <div className="voice-add__picker">
    <AsyncSelect
      className="voice-add__picker-select"
      classNamePrefix="voice-add-select"
      cacheOptions
      defaultOptions={false}
      loadOptions={searchMembers}
      onChange={(option) => option && onSelect(option.value)}
      placeholder="Type a name or phone…"
      noOptionsMessage={({ inputValue }) =>
        inputValue && inputValue.length >= 2
          ? "No members found"
          : "Type at least 2 characters"
      }
      autoFocus
    />
    <button type="button" className="voice-add__btn" onClick={onCancel}>
      Cancel
    </button>
  </div>
);
